import { Paper, Popover, styled } from '@mui/material';

export const StyledProfilePopoverColorPickerItemWrap = styled(Paper)({
	borderRadius: '8px',
	padding: '8px 16px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	cursor: 'pointer',
	position: 'relative',
});

export const StyledProfilePopoverColorPickerItemColor = styled('div')({
	width: '32px',
	height: '32px',
	borderRadius: '50%',
});

export const StyledProfilePopoverColorPickerWrap = styled(Popover)({
	'& .MuiPaper-root': {
		background: '#FFF',
		padding: '16px',
	},
});
